import React from 'react';
import dompurify from 'dompurify';

interface PurifiedContentProps {
  children?: any;
}

const PurifiedContent = ({ children }: PurifiedContentProps) => {
  return (
    <div
      className="html-container"
      dangerouslySetInnerHTML={{
        __html: dompurify.sanitize(children, { ADD_ATTR: ['target', 'alt'] }),
      }}
    />
  );
};

export default PurifiedContent;
